import { Skeleton, styled } from '@mui/joy';
import Stack, { StackProps } from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

type InfoBoxProps = StackProps & {
  label?: string;
  button?: React.ReactNode;
  loading?: boolean;
  labelSkeletonWidth?: string;
};

export const InfoBox = ({
  label,
  children,
  gap = 2,
  button,
  loading = false,
  labelSkeletonWidth = '140px',
  ...props
}: InfoBoxProps) => {
  return (
    <Stack
      sx={{
        border: theme =>
          `0.5px solid ${theme.palette.isDarkMode ? theme.palette.neutral[350] : theme.palette.neutral[300]}`,
        borderRadius: theme => theme.spacing(1),
        padding: 2,
        gap,
      }}
      {...props}
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{ width: '100%' }}
      >
        {label && (
          <Typography level='title-sm' fontWeight={600} textColor='neutral.700'>
            <Skeleton
              variant='text'
              loading={loading}
              level='title-sm'
              sx={{ width: labelSkeletonWidth, borderRadius: '8px' }}
            >
              {!loading && label}
            </Skeleton>
          </Typography>
        )}
        {button}
      </Stack>

      {children}
    </Stack>
  );
};

export const InfoBoxRow = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(2)};
  & > * {
    flex: 1;
  }
`;

export const InformationContainer = styled(Stack)`
  overflow: auto;
`;
